export const useUIStore = defineStore('ui', () => {
  const isDark = ref(false)

  const panelLeft = ref(20)
  const panelRight = ref(20)
  const panelBody = computed(() => 100 - panelLeft.value - panelRight.value)

  const isCollapsed = ref(false)

  if (process.browser) {
    isCollapsed.value = localStorage.getItem('_isCollapsed') === 'true'

    watch(isDark, (value) => {
      localStorage.setItem('isDark', value.toString())
      document.documentElement.classList.toggle('dark', value)
    })

    watch(isCollapsed, (value) => {
      debounce(() => {
        localStorage.setItem('_isCollapsed', value.toString())
      }, 500)
    })
  }

  const toggleAppSidebar = () => {
    isCollapsed.value = !isCollapsed.value
  }

  return { isDark, isCollapsed, panelLeft, panelRight, panelBody, toggleAppSidebar }
})
